import React from 'react';
import cn from 'classnames';
import Image from 'next/image';

import styles from './BucketListBlockItem.module.scss';
import Props from './BucketListBlockItem.props';
import { Link } from '@components/containers';

const BucketListBlockItem = ({ thumbnail, title, excerpt, url, className }: Props) => {
  return (
    <Link href={url}>
      <article className={cn(styles.BucketListBlockItem, className)}>
        <div className={styles.Thumbnail}>
          <div className={styles.ImageWrapper}>
            <Image src={thumbnail} alt="" quality={60} layout="fill" />
          </div>
        </div>
        <div className={styles.Content}>
          <h1 className={styles.Title}>{title}</h1>
          <p className={styles.Description} dangerouslySetInnerHTML={{ __html: excerpt }} />
        </div>
      </article>
    </Link>
  );
};

export default BucketListBlockItem;
